import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, ImageIcon, MailIcon, PhoneIcon } from 'lucide-react';
import { Button, LinkButton } from '../ui/Button';
import { TextArea, TextField } from '../ui/Field';
import { useAdminData } from '../../contexts/AdminDataContext';
import { company } from '../../data/site';
const ease = [0.23, 1, 0.32, 1] as const;
const emptyForm = {
  name: '',
  phone: '',
  email: '',
  address: '',
  description: ''
};
export function ContactSection() {
  const {
    createEnquiry
  } = useAdminData();
  const [form, setForm] = useState(emptyForm);
  const [photos, setPhotos] = useState<{
    url: string;
    name: string;
  }[]>([]);
  const [sent, setSent] = useState(false);
  return <section id="kontakt" className="scroll-mt-24" data-id="element-70" data-mp="zdkrgwpjtsi8">
      <div className="mx-auto max-w-content px-5 py-16 md:py-24 lg:px-8" data-id="element-71" data-mp="zevxz4adped1">
        <div className="grid gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16" data-id="element-72" data-mp="1dckho8spmfgi">
          <div className="lg:sticky lg:top-28 lg:self-start" data-id="element-73" data-mp="18eiy7mrdge4i">
            <h2 className="font-display text-[clamp(2rem,5.5vw,3.5rem)] font-bold leading-[1.05] tracking-tight text-ink" data-id="element-74" data-mp="3lilbmipkgxnm">
              Fortæl om din opgave
            </h2>
            <p className="mt-5 max-w-md text-[17px] leading-relaxed text-ink-soft" data-id="element-75" data-mp="3qj9cdw3lksv1">
              Beskriv kort hvad du skal have lavet. Du må meget gerne vedhæfte billeder, så er det nemmere at
              vurdere opgaven.
            </p>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row lg:flex-col" data-id="element-76" data-mp="8cl6i40q41ob">
              <LinkButton href={company.phoneHref} variant="secondary" size="lg" className="sm:w-auto lg:w-full" data-id="element-77" data-mp="damsawpjaf3h">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-78" data-mp="i1cuk12ny1ty" />
                {company.phone}
              </LinkButton>
              <LinkButton href={`mailto:${company.email}`} variant="secondary" size="lg" className="sm:w-auto lg:w-full" data-id="element-79" data-mp="mzegctrh4f94">
                <MailIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="w1xe4zgek1oi" />
                {company.email}
              </LinkButton>
            </div>
          </div>

          {sent ? <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.28,
          ease
        }} role="status" className="flex flex-col items-start rounded-card border border-line bg-white p-8 md:p-12" data-id="element-81" data-mp="2o3yq3tpdmnxu">
              <span className="inline-flex h-12 w-12 items-center justify-center rounded-full bg-accent-soft text-accent-deep" data-id="element-82" data-mp="3bqyjon2f4xq9">
                <CheckIcon className="h-6 w-6" aria-hidden="true" data-id="element-83" data-mp="36vrltvvtyn99" />
              </span>
              <h3 className="mt-6 font-display text-2xl font-bold tracking-tight text-ink md:text-3xl" data-id="element-84" data-mp="3kr3m0isr95xk">
                Tak for din henvendelse.
              </h3>
              <p className="mt-3 text-[17px] text-ink-soft" data-id="element-85" data-mp="1qfyc4wr2rx9s">LYKKEVÆRK vender tilbage hurtigst muligt.</p>
              <Button variant="secondary" size="md" className="mt-8" onClick={() => {
            setSent(false);
            setPhotos([]);
          }} data-id="element-86" data-mp="1lhdkvmtswnxh">
                Send en opgave mere
              </Button>
            </motion.div> : <form className="rounded-card border border-line bg-white p-6 md:p-9" onSubmit={event => {
          event.preventDefault();
          createEnquiry({
            ...form,
            photos
          });
          setForm(emptyForm);
          setSent(true);
        }} data-id="element-87" data-mp="3scpamhfmx0vz">
              <div className="grid gap-5 sm:grid-cols-2" data-id="element-88" data-mp="35crm93opv0n1">
                <TextField id="navn" label="Navn" required autoComplete="name" placeholder="Dit navn" value={form.name} onChange={event => setForm({
              ...form,
              name: event.target.value
            })} data-id="element-89" data-mp="35ecaycocnpcz" />
                <TextField id="telefon" label="Telefonnummer" required type="tel" autoComplete="tel" placeholder="+45" value={form.phone} onChange={event => setForm({
              ...form,
              phone: event.target.value
            })} data-id="element-90" data-mp="iwdkqzhc6ogq" />
                <TextField id="email" label="E-mail" type="email" autoComplete="email" placeholder="dig@mail.dk" value={form.email} onChange={event => setForm({
              ...form,
              email: event.target.value
            })} data-id="element-91" data-mp="40xk2bm93ubd" />
                <TextField id="omraade" label="Adresse eller område" autoComplete="street-address" placeholder="Fx Hvidovre" value={form.address} onChange={event => setForm({
              ...form,
              address: event.target.value
            })} data-id="element-92" data-mp="3heitnnsyqxy7" />
              </div>

              <TextArea id="beskrivelse" label="Beskrivelse af opgaven" required className="mt-5" placeholder="Fortæl kort hvad der skal laves." value={form.description} onChange={event => setForm({
            ...form,
            description: event.target.value
          })} data-id="element-93" data-mp="1rwc5bsn1bafd" />

              <div className="mt-5" data-id="element-94" data-mp="144omlxzxf5o6">
                <p className="mb-1.5 text-sm font-medium text-ink" data-id="element-95" data-mp="195b93cdatszi">Upload billeder</p>
                <label htmlFor="billeder" className="flex cursor-pointer flex-col items-center justify-center gap-1.5 rounded-xl border border-dashed border-line bg-canvas px-6 py-7 text-center transition-colors duration-200 ease-smooth hover:border-accent/60" data-id="element-96" data-mp="1e4xjle1qsv4m">
                  <ImageIcon className="h-5 w-5 text-ink-muted" strokeWidth={1.5} aria-hidden="true" data-id="element-97" data-mp="qethjb47d3fq" />
                  <span className="text-[15px] font-medium text-ink" data-id="element-98" data-mp="ie5hhh784dnu">Vælg billeder</span>
                  <span className="text-sm text-ink-muted" data-id="element-99" data-mp="edbtknts6yuy">Valgfrit, men det gør vurderingen nemmere</span>
                  <input id="billeder" type="file" multiple accept="image/*" className="sr-only" onChange={event => setPhotos(Array.from(event.target.files ?? []).map(file => ({
                url: URL.createObjectURL(file),
                name: file.name
              })))} data-id="element-100" data-mp="s500mcp6ax52" />
                </label>
                {photos.length > 0 && <ul className="mt-3 flex flex-wrap gap-2" data-id="element-101" data-mp="1kscm0jjlkyws">
                    {photos.map(photo => <li key={photo.name} className="rounded-full border border-line bg-canvas px-3 py-1.5 text-xs text-ink-soft" data-id="element-102" data-mp="1fszu3kdvd1nc">
                        {photo.name}
                      </li>)}
                  </ul>}
              </div>

              <Button type="submit" size="lg" className="mt-7 w-full text-lg" data-id="element-103" data-mp="2otcco5zeg4ic">
                Send forespørgsel
              </Button>
            </form>}
        </div>
      </div>
    </section>;
}